import { StowageInstructionDto } from '@planning/app/api'
import { stowageInstructionService } from '@planning/services'
import { action, makeObservable, observable } from 'mobx'

export class StowageInstructionAutocompleteViewStore {
  fetched = false
  options: StowageInstructionDto[] = []

  constructor() {
    makeObservable(this, {
      fetched: observable,
      options: observable,

      fetchOptions: action,
    })
  }
  async fetchOptions() {
    if (this.fetched) return
    const instructions = await stowageInstructionService.get()
    this.options = instructions
    this.fetched = true
  }
}
